import * as svg from "../../../assets/vrbo-logo-solid-circle.svg";

import {iconBuilder} from "./iconBuilder";

export const VRBOCircleIcon = iconBuilder(svg, "VRBOCircleIcon", "0 0 1150.9 1150.9");
